export const FeatureName = 'subsidiaryDetail';
